import { MijnRoute } from '../../mijn-navigatie.model';

export const COLLECTION_REFUSE: MijnRoute = {
    path: 'incasso-weigeren',
    navigationEvent: 'toIncassoRefuse',
    regex: /^\/incasso\/incasso-weigeren$/,
    webcomponent: 'mijn-transacties-incasso-webcomponent',
    internalPath: '/incasso-weigeren'
};
